
<template>
  <div class="card mb-25 border-0 rounded-0 mb-20">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
      >
        <div class="title">
          <h5 class="card-title fw-black mb-0">{{ form.code }}</h5>
        </div>
      </div>
      <form>
        <div class="row">
          <template v-if="row.invoiced != 1">
            <div class="col-12 col-md-12 mb-3">
              <label for="colis">Ouvrir Colis</label>
              <select id="colis" class="form-control" v-model="OpenColi">
                <option
                  v-for="option in ColisList"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
           <!-- <div class="col-12 col-md-6 mb-3">
              <label for="fragile">Fragile</label>
              <select id="fragile" class="form-control" v-model="fragile">
                <option
                  v-for="option in FragileColis"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>-->
          </template>
          <div class="col-12 col-md-6 mb-3" style="margin-top: 3%">
            <div>
              <input
                type="radio"
                id="replace0"
                value="0"
                v-model="ReplaceColis"
                class="form-check-input"
              />
              <label for="replace0" class="form-check-label"
                >Colis Simple</label
              >
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3" style="margin-top: 3%">
            <div>
              <input
                type="radio"
                id="replace1"
                value="1"
                v-model="ReplaceColis"
                class="form-check-input"
              />
              <label for="replace1" class="form-check-label">
                Colis Change
                <span v-if="Number(ReplaceColis) == 1" style="font-size: 12px">
                  <br />
                  Le colis sera remplacer avec le colis :
                </span>
              </label>
              <div v-if="Number(ReplaceColis) == 1" class="mt-2">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Code de suivi"
                  v-model="form.code_replace"
                  @change="SearchColis"
                />
                <small class="text-error" v-if="existcolis"
                  >Ce colis n'existe pas</small
                >
                <small class="text-error" v-if="replacecolis"
                  >Vous pouvez pas remplacer ce colis</small
                >
              </div>
            </div>
          </div>

          <div class="col-12">
            <hr />
          </div>
        </div>
        <div class="row">
          <template v-if="row.invoiced != 1">
            <div class="col-12 col-md-6 mb-3">
              <label for="dest">Destinataire</label>
              <input
                id="dest"
                class="form-control"
                v-model="form.receiver"
                required
              />
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="phone">Téléphone</label>
              <input
                id="phone"
                class="form-control"
                v-model="form.phone"
                type="number"
                pattern="^([0][0-9]{9})$"
                @keypress="
                  if (isNaN(Number($event.key))) $event.preventDefault();
                "
              />
            </div>
            <template v-if="auth.can('PARCELS_EDIT_CITY')">
              <div class="col-12 col-md-6 mb-3">
                <label for="city">Ville</label>
                <v-select
                  class="custom-select-height"
                  id="city"
                  required
                  label="name"
                  v-model="city"
                  :options="CitiesList"
                  placeholder="Ville"
                  @input="showFees(city)"
                />
              </div>
            </template>
            <template v-else>
              <div class="col-12 col-md-6 mb-3"></div>
            </template>

            <div class="col-12 col-md-6 mb-3">
              <label for="price">Prix</label>
              <input
                id="price"
                class="form-control"
                v-model="form.price"
                disabled
              />
            </div>
            <!-- <div class="col-12 col-md-6 mb-3">
              <label for="quartier">Quartier</label>
              <select id="quartier" class="form-control" v-model="quartier">
                <option v-for="option in QuartierList" :key="option.value" :value="option.value">
                  {{ option.name }}
                </option>
              </select>
            </div> -->
            <div class="col-12 col-md-6 mb-3">
              <label for="adresse">Adresse</label>
              <textarea
                name="adresse"
                rows="3"
                class="form-control"
                v-model="form.address"
              ></textarea>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="comment">Commentaire</label>
              <textarea
                name="comment"
                rows="3"
                class="form-control"
                v-model="form.note"
              ></textarea>
            </div>

            <template
              v-if="auth.can('PARCELS') && auth.can('EDIT_FEES_PARCELS')"
            >
              <div class="col-12 col-md-4 mb-3">
                <label for="fl">Frais de livraison *</label>
                <input
                  style="color: #f14d12"
                  id="fl"
                  class="form-control"
                  v-model="form.delivered_fees"
                  disabled
                />
              </div>
              <div class="col-12 col-md-4 mb-3">
                <label for="frn">Frais de retour *</label>
                <input
                  style="color: #f14d12"
                  id="frn"
                  class="form-control"
                  v-model="form.returned_fees"
                  disabled
                />
              </div>
              <div class="col-12 col-md-4 mb-3">
                <label for="frs">Frais de refus *</label>
                <input
                  style="color: #f14d12"
                  id="frs"
                  class="form-control"
                  v-model="form.refused_fees"
                  disabled
                />
              </div>
            </template>
          </template>

          <div class="col-12 mb-10">
            <button
              v-if="auth.can('PARCELS')"
              type="button"
              class="btn btn-primary float-right mb-1 mb-sm-0 mr-0 mr-sm-1"
              :disabled="load || isload"
              @click="AddColis"
            >
              Enregistrer
              <span
                v-if="load || isload"
                class="spinner-border spinner-border-sm"
              ></span>
            </button>
          </div>
          <template
            v-if="
              (row.status == 'DELIVERED' ||
                row.status == 'DELIVERED_PARTIAL') &&
              row.paid_livreur == 0 &&
              row.livreur != 0 &&
              row.invoiced != 1
            "
          >
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12">
              <center>
                <h2><b>Changer le livreur</b></h2>
              </center>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label>Ancien Livreur</label>
              <input
                class="form-control"
                style="color: #f14d12"
                :value="
                  row.driver && row.driver.livreur_name
                    ? row.driver.livreur_name
                    : row.livreur_name
                "
                disabled
              />
            </div>
            <div class="col-12 col-md-4 mb-3">
              <label>Nouveau Livreur</label>
              <v-select
                class="custom-select-height"
                required
                label="name"
                v-model="livreur"
                :options="LivsList"
                placeholder="Ville"
              />
            </div>
            <div class="col-12 col-md-4 mb-3">
              <button
                v-if="auth.can('PARCELS')"
                type="button"
                class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1"
                @click="EditLivreur"
                style="margin-top: 6%"
              >
                Modifier
              </button>
            </div>
          </template>

          <template
            v-if="
              auth.can('PARCELS') &&
              (user?.role_id == 1 || user?.role_id == 2) &&
              (row.status == 'DELIVERED' ||
                row.status == 'DELIVERED_PARTIAL') &&
              row.situation != 'INVOICED' &&
              row.invoiced != 1
            "
          >
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12">
              <center>
                <h2><b>Colis non livré</b></h2>
              </center>
            </div>
            <div class="col-12">
              <center>
                <button
                  type="button"
                  class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1"
                  @click="EditLivredStatut"
                  style="margin-top: 1%"
                  title="Modifier status (Non Livré)"
                >
                  Colis non livré
                </button>
              </center>
            </div>
          </template>
          <template
            v-if="
              row.status == 'IN_PROGRESS' &&
              row.status_second == 'REFUSE' &&
              row.situation == 'Facturé' &&
              row.invoiced == 1
            "
          >
            <div class="col-12">
              <center>
                <button
                  type="button"
                  class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1"
                  @click="ToDistribution"
                  style="margin-top: 1%"
                  title="Modifier status (Non Livré)"
                >
                  Changer en mise en distribution
                </button>
              </center>
            </div>
          </template>
        </div>
      </form>
    </div>
  </div>
</template>
<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import { defineComponent, onMounted, reactive, ref, watch } from "vue";

export default defineComponent({
  name: "UpdateParcel",

  props: {
    rowColis: {
      type: Object,
      required: true,
    },
    getRecords: {
      type: Function,
      required: true,
    },
    isOpenEdit: {
      type: Boolean,
      required: true,
    },
    hideModal: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const form = ref({
      id: 0,
      code: "",
      price: "",
      phone: "",
      delivered_fees: "",
      returned_fees: "",
      refused_fees: "",
      receiver: "",
      address: "",
      note: "",
      customer: 0,
      partial_send: null,
      partial_return: null,
      code_replace: null,
      liv_fees_refused: "",
      liv_fees_livred: "",
    });
    const QuartierList = ref([]);
    const quartier = ref({ id: 0, name: "" });
    const CitiesList = ref([]);
    const city = ref({ id: 0, name: null });
    const ColisList = ref([
      { value: 1, text: "Ouvrir le colis" },
      { value: 0, text: "Ne pas ouvrir le colis" },
    ]);
    const OpenColi = ref({ value: 0, text: "Ne pas ouvrir le colis" });
    const FragileColis = ref([
      { value: 1, text: "Oui" },
      { value: 0, text: "Non" },
    ]);
    const fragile = ref({ value: 0, text: "Non" });
    const ReplaceColis = ref(0);
    const existcolis = ref(false);
    const replacecolis = ref(false);
    const load = ref(false);
    const LivsList = ref([]);
    const livreur = ref<any>({});
    const isload = ref(false);

    async function getData() {
      if (
        (props.rowColis.status == "DELIVERED" ||
          props.rowColis.status == "DELIVERED_PARTIAL") &&
        props.rowColis.paid_livreur == 0
      ) {
        try {
          const res = await api.get(
            `/api/auth/LivsTochange/${props.rowColis.city_id}`
          );
          LivsList.value = res.data.data || [];
        } catch (err) {
          console.log(err);
        }
      }

      // Reset form fields manually
      form.value = {
        id: props.rowColis.id || 0,
        code: props.rowColis.code || "",
        price: props.rowColis.price || "",
        phone: props.rowColis.phone ? oldPhone(props.rowColis.phone) : "",
        delivered_fees: props.rowColis.delivered_fees || "",
        returned_fees: props.rowColis.returned_fees || "",
        refused_fees: props.rowColis.refused_fees || "",
        receiver: props.rowColis.receiver || "",
        address: props.rowColis.address || "",
        note: props.rowColis.note || "",
        customer: props.rowColis.customer || 0,
        partial_send: props.rowColis.partial_send || null,
        partial_return: props.rowColis.partial_return || null,
        code_replace: props.rowColis.code_replace || null,
        liv_fees_refused: props.rowColis.liv_fees_refused || "",
        liv_fees_livred: props.rowColis.liv_fees_livred || "",
      };
      city.value.name = props.rowColis.city_name || null;
      city.value.id = props.rowColis.city_id || 0;
      // quartier.value.id = props.rowColis.quartier_id || 0;
      if (props.rowColis.can_open == 1) {
        OpenColi.value = { value: 1, text: "Ouvrir le colis" };
      } else {
        OpenColi.value = { value: 0, text: "Ne pas ouvrir le colis" };
      }
      if (props.rowColis.fragile == 1) {
        fragile.value = { value: 1, text: "Oui" };
      } else {
        fragile.value = { value: 0, text: "Non" };
      }
      if (props.rowColis.replace == 1) {
        ReplaceColis.value = 1;
      } else if (props.rowColis.partial == 1) {
        ReplaceColis.value = 2;
      }
    }

    onMounted(async () => {
      console.log("open ", props.isOpenEdit);
      if (props.isOpenEdit) {
        getData();
        try {
          const res = await api.get("/api/auth/citiesList");
          CitiesList.value = res.data;
        } catch (err) {
          console.log(err);
        }
      }
    });
    const row = ref<any>({});
    watch(
      () => props.isOpenEdit,
      (newVal) => {
        console.log("isOpenEdit changed:", newVal);
        if (newVal) {
          getData();
          row.value = props.rowColis;
          console.log("row edit", row.value);
        }
      },
      { immediate: true }
    );

    function oldPhone(val) {
      if (val && val !== "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) === "+212" && val.length === 13) {
          return `0${val.slice(4)}`;
        }
        if (val.substring(0, 3) === "212" && val.length === 12) {
          phone = `0${val.slice(2)}`;
          return phone;
        }
        if (val.substring(0, 1) === "0" && val.length === 10) {
          return val;
        }
        if (
          val.substring(0, 1) === "6" ||
          (val.substring(0, 1) === "7" && val.length === 9)
        ) {
          // phone = "+212" + val;
          return val;
        }
        if (val.substring(0, 5) === "00212" && val.length === 14) {
          return `0${val.substring(0, 5)}`;
        }
      } else {
        return val;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function showFees(city: { id: number }) {
      isload.value = true;
      api
        .get(
          `/api/auth/GetFeesLivred?city=${city.id}&customer=${form.value.customer}`
        )
        .then((res) => {
          if (res.data) {
            form.value.delivered_fees = res.data.liv_fees;
            form.value.returned_fees = res.data.return_fees;
            form.value.refused_fees = res.data.refus_fees;
          }
        })
        .finally(() => {
          isload.value = false;
        });
    }

    function SearchColis() {
      existcolis.value = false;
      replacecolis.value = false;
      let data = new FormData();
      data.append(
        "user_id",
        String(auth.user?.id ?? "")
      );
      data.append("codesuivi", String(form.value.code_replace ?? ""));
      api.post(`/api/auth/ColisExist`, data).then((res) => {
        if (res.data === "not exist") {
          existcolis.value = true;
        } else if (res.data === "exist") {
          existcolis.value = false;
        } else if (res.data === "error status") {
          replacecolis.value = true;
        }
      });
    }

    function AddColis() {
      if (
        !city.value.id ||
        !form.value.receiver ||
        !form.value.phone ||
        !form.value.address
      ) {
        showToast("Merci de remplire tous les champs", "error");
      } else {
        let data = new FormData();
        data.append(
          "userID",
          String(auth.user?.id ?? "")
        );
        data.append("code", String(form.value.code));
        data.append("city_name", String(city.value.name));
        data.append("city_id", String(city.value.id));
        data.append("quartier_id", String(quartier.value.id));
        data.append("price", String(form.value.price));
        data.append("phone", String(form.value.phone));
        data.append("address", String(form.value.address));
        data.append("note", String(form.value.note));
        data.append("delivered_fees", String(form.value.delivered_fees));
        data.append("returned_fees", String(form.value.returned_fees));
        data.append("refused_fees", String(form.value.refused_fees));
        data.append("receiver", String(form.value.receiver));
        data.append("fragile", String(fragile.value.value));
        data.append("can_open", String(OpenColi.value.value));
        data.append("replace", String(ReplaceColis.value));
        data.append(
          "codereplace",
          form.value.code_replace == null ? "" : String(form.value.code_replace)
        );
        data.append("partial_send", String(form.value.partial_send ?? ""));
        data.append("partial_return", String(form.value.partial_return ?? ""));

        load.value = true;
        api
          .post(`/api/auth/coli_edit/${form.value.id}`, data)
          .then((res) => {
            load.value = false;
            if (res.data.message == "success") {
              props.getRecords();
              // Hide modal logic here if needed
              showToast("Les données sont bien sauvegardés", "success");
              if (props.hideModal) {
                props.hideModal("modal_update");
              }
            } else if (
              res.data.message == "no edit" ||
              res.data.message == "no access"
            ) {
              showToast("Vous pouvez pas modifier ce colis", "error");
            } else if (res.data.message == "error replace") {
              showToast("Code colis à changer est invalide", "error");
            }
          })
          .catch(() => {
            showToast("Something went wrong! Please try again", "error");
          });
      }
    }

    function EditLivreur() {
      if (!livreur.value.id) {
        showToast("Merci de choisir le nouveau livreur", "error");
      } else {
        let data = new FormData();
        data.append(
          "userID",
          String(auth.user?.id ?? "")
        );
        data.append("code", String(form.value.code));
        data.append("liv_id", String(livreur.value.id));
        data.append("liv_name", String(livreur.value.name));
        api
          .post(`/api/auth/coli_edit_livreur/${form.value.id}`, data)
          .then((res) => {
            load.value = false;
            if (res.data.message == "success") {
              props.getRecords();
              showToast("Les données sont bien sauvegardés", "success");
            } else if (
              res.data.message == "no user" ||
              res.data.message == "no parcel"
            ) {
              showToast("Vous pouvez pas modifier ce colis", "error");
            }
          })
          .catch(() => {
            showToast("Something went wrong! Please try again", "error");
          });
      }
    }

    function EditLivredStatut() {
      // You can use a modal library or native confirm for confirmation
      if (
        (props.rowColis.status == "DELIVERED" ||
          props.rowColis.status == "DELIVERED_PARTIAL") &&
        props.rowColis.invoiced == 0
      ) {
        api
          .post(`/api/auth/EditDeliverd/${props.rowColis.id}`)
          .then((res) => {
            if (res.data.message == "success") {
              props.getRecords();
              showToast("le status est bien modifié", "success");
            } else if (res.data.message == "paid parcel") {
              showToast(
                "Vous pouvez pas modifier ! Ce colis est enregistré dans un bon de paiment ",
                "error"
              );
            } else if (
              res.data.message == "no edit" ||
              res.data.message == "no parcel"
            ) {
              showToast("Vous pouvez pas modifier ce colis !", "error");
            }
          })
          .catch(() => {
            showToast("Something went wrong! Please try again", "error");
          });
      } else {
        showToast("Vous pouvez pas modifier le statut de ce colis", "error");
      }
    }

    function ToDistribution() {
      if (
        props.rowColis.status != "DELIVERED" &&
        props.rowColis.status != "DELIVERED_PARTIAL" &&
        (props.rowColis.situation === "PAID" ||
          props.rowColis.situation === "Payé")
      ) {
        showToast("Vous pouvez pas modifier le statut de ce colis", "error");
      } else {
        api
          .post(`/api/auth/EditToDistr/${props.rowColis.id}`)
          .then((res) => {
            if (res.data.message == "success") {
              props.getRecords();
              showToast("le status est bien modifié", "success");
            } else if (
              res.data.message == "no edit" ||
              res.data.message == "no parcel"
            ) {
              showToast("Vous pouvez pas modifier ce colis !", "error");
            }
          })
          .catch(() => {
            showToast("Something went wrong! Please try again", "error");
          });
      }
    }

    return {
      auth,
      getDate,
      form,
      QuartierList,
      quartier,
      CitiesList,
      city,
      ColisList,
      OpenColi,
      FragileColis,
      fragile,
      ReplaceColis,
      existcolis,
      replacecolis,
      load,
      LivsList,
      livreur,
      isload,
      showFees,
      SearchColis,
      AddColis,
      EditLivreur,
      EditLivredStatut,
      ToDistribution,
      row,
      user,
    };
  },
});
</script>
